import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { ISsoStore } from '../../stores/SsoStore';

import { ITranslateStore } from '../../stores/TranslateStore';

import NoticeWithButton from './NoticeWithButton';

interface ILoginRequiredNoticeProps {
  translateStore?: ITranslateStore;
  ssoStore?: ISsoStore;
}

@inject('translateStore', 'ssoStore')
@observer
export default class LoginRequiredNotice extends React.Component<ILoginRequiredNoticeProps> {
  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;
    const ssoStore = this.props.ssoStore;
    return (
      <NoticeWithButton
        gaEvent="CTA - log in"
        noticeText={translate('shared.notices.login-required')}
        buttonProps={{
          type: 'primary',
          text: translate('shared.notices.login-required.login-button'),
          onClick: () => ssoStore.openSsoFrame()
        }}
      />
    );
  }
}
